var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCyberRecovery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16367",
    "data-name": "Group 16367",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.901,
    height: 61.358,
    viewBox: "0 0 68.901 61.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8937",
    "data-name": "Rectangle 8937",
    width: 68.901,
    height: 61.358,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16367-2",
    "data-name": "Group 16367",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10603",
    "data-name": "Path 10603",
    d: "M15.95,57.425a8.679,8.679,0,0,1-6.163-2.69,7.627,7.627,0,0,1-.678-.72,8.947,8.947,0,0,1,1.059-12.581L29.1,22.542A15.321,15.321,0,0,1,33.317,8.288,16.2,16.2,0,0,1,51.045,4.772l2.923,1.207-8.811,8.853a3.171,3.171,0,0,0-.932,2.266,3.2,3.2,0,0,0,5.464,2.266l8.853-8.853,1.228,2.9a16.213,16.213,0,0,1-3.452,17.812,15.384,15.384,0,0,1-14.466,4.067l-19.02,19.02a9.924,9.924,0,0,1-6.883,3.113M44.818,7.779a12.017,12.017,0,0,0-8.493,3.537,11.117,11.117,0,0,0-2.817,11.268l.381,1.228L13.048,44.59A4.732,4.732,0,0,0,12.37,51.3c.106.127.254.275.381.4a4.482,4.482,0,0,0,3.219,1.5,5.65,5.65,0,0,0,3.855-1.885L40.667,30.484l1.25.424a11.128,11.128,0,0,0,11.395-2.669,11.969,11.969,0,0,0,3.431-9.912L52.7,22.372a7.586,7.586,0,0,1-10.505,0,7.414,7.414,0,0,1,0-10.505l3.982-4a9.912,9.912,0,0,0-1.356-.085",
    transform: "translate(7.835 3.933)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10604",
    "data-name": "Path 10604",
    d: "M11.691,47.041H4.236V16.711H33.443a20.224,20.224,0,0,1,2.1-4.236H4.236V4.257H46.278a20.365,20.365,0,0,1,12.708,0h3.135V5.464l4.236,1.758V0H0V51.256H10.654a13.375,13.375,0,0,1,1.038-4.215",
    transform: "translate(0 0)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10605",
    "data-name": "Path 10605",
    d: "M39.112,21.242v5.295h-14.3L20.58,30.773H43.348V18.34a20.024,20.024,0,0,1-4.236,2.9",
    transform: "translate(23.008 20.504)",
    fill: "#444"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberRecovery);
export default __webpack_public_path__ + "static/media/cyber-recovery.2c4684c186d15e1b7836c85f527051cb.svg";
export { ForwardRef as ReactComponent };